import { select, call, put, take } from 'redux-saga/effects';
import { logDmbErrorLocation } from '../utils/error';
import { CropAction, receiveCropList } from '../actions/cropActions';
import { olConnectionV2 } from '../requesters/olConnection';
import { getCropListQuery } from '../queries/getCropList';
import { extractCropListFromSprout } from '../utils/cropData';
import { StoreCrops } from '../types';
import { getCrops } from '../selectors';

export function* getCropList() {
  let cropList: StoreCrops;

  try {
    const response = yield call(olConnectionV2, getCropListQuery());
    cropList = extractCropListFromSprout(response);

    yield put(receiveCropList(cropList));
  } catch (error) {
    const errText = 'Error fetching crop list';
    logDmbErrorLocation(error, errText);
  }
}

export function* getCropMap() {
  let cropsMap = yield select(getCrops);
  if (Object.keys(cropsMap).length === 0) {
    const cropListAction = yield take(CropAction.ReceiveCropList);
    cropsMap = cropListAction.cropList;
  }

  return cropsMap;
}